enum SeriesTabType {
  About = "About",
  Pieces = "Pieces",
}

export default SeriesTabType;
